import { Route } from 'react-router-dom';
import ProjectsPage from '../ProjectsPage';

const ProjectTopicRouter: React.FC = () => (
  <>
    <Route
      path={['/projects/:projectId/topics/', '/projects/:projectId/topic/']}
      component={ProjectsPage}
    />
  </>
);

export default ProjectTopicRouter;
